const excludeSubject = ["english"];

export default excludeSubject;
